import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PickupOrderItem {
  product_id: string;
  quantity: number;
}

export interface PickupOrderInput {
  producer_id: string;
  items: PickupOrderItem[];
  customer_email: string;
  customer_name?: string;
  customer_phone?: string;
  customer_note?: string;
  client_request_id?: string;
  pickup_window_id?: string;
}

export interface PickupOrderResult {
  order_id: string;
  order_number: string;
  total_amount: number;
}

export function useCreatePickupOrder() {
  return useMutation<PickupOrderResult, Error, PickupOrderInput>({
    mutationFn: async (input) => {
      const requestId = input.client_request_id ?? crypto.randomUUID();

      const { data, error } = await supabase.rpc('create_pickup_order', {
        p_producer_id: input.producer_id,
        p_items: input.items as any,
        p_customer_email: input.customer_email,
        p_customer_name: input.customer_name ?? null,
        p_customer_phone: input.customer_phone ?? null,
        p_customer_note: input.customer_note ?? null,
        p_client_request_id: requestId,
        p_pickup_window_id: input.pickup_window_id ?? null,
      } as any);

      if (error) throw new Error(error.message);
      return data as unknown as PickupOrderResult;
    },
  });
}
